import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import {useHistory, useLocation} from 'react-router-dom';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool
} from 'amazon-cognito-identity-js';
import LoginFormView from './LoginForm-view';
import {pathnames as P} from 'common/constants/pathnames';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {transformUserAttributes} from 'modules/Auth/utils/cognito/transformUserAttributes';
import {extractUserSessionTokens} from 'modules/Auth/utils/cognito/extractUserSessionTokens';
import {cognitoErrors} from 'common/constants/errors';

import cognitoConfig from 'config/cognito';
const { PoolData } = cognitoConfig;

const LoginForm = ({setUser, login}) => {
  const [errorMessage, setErrorMessage] = useState('');
  const history = useHistory();
  const location = useLocation();
  const initialValues = {
    username: '',
    password: ''
  };

  const validate = values => {
    return checkRequiredValues(values);
  };

  const handleSubmit = values => {
    loginToCognito(values)
      .then(login)
      .then(() => history.push(P.MAIN_MENU))
      .catch(err => {
        console.error(err);
        showErrorMessagePopup(cognitoErrors[err.code] || err.message || JSON.stringify(err))
      })
  };

  const loginToCognito = ({username, password}) => {
    const userPool = new CognitoUserPool(PoolData);
    const authenticationData = {
      Username: username,
      Password: password,
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const userData = {
      Username: username,
      Pool: userPool,
    };
    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: userSession => getTokens(userSession)
          .then(tokens => fetchUserAttributes(cognitoUser, tokens))
          .then(data => transformLoginData(data, resolve))
          .catch(rejectWithMessage(reject)),
        onFailure: rejectWithMessage(reject),
      });
    });
  };

  const fetchUserAttributes = (cognitoUser, tokens) => {
    return new Promise(((resolve, reject) => {
      cognitoUser.getUserAttributes((err, result) => {
        if (err) return rejectWithMessage(reject);
        const attributes = transformUserAttributes(result);
        setUser({...cognitoUser, attributes});
        resolve({tokens, attributes})
      });
    }))
  };

  const transformLoginData = (data, resolve) => {
    const {tokens, attributes: {email}} = data;
    return resolve({tokens, email});
  };

  const getTokens = async userSession => {
    return extractUserSessionTokens(userSession);
  };

  const rejectWithMessage = reject => err => {
    const errText = cognitoErrors[err.code] || err.message || JSON.stringify(err);
    reject(errText);
  };

  const goToRegister = () => {
    history.push(P.AUTH_REGISTER)
  };

  const showErrorMessagePopup = message => {
    setErrorMessage(message);
    history.push(`${location.pathname}/message`)
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <LoginFormView
          {...formikProps}
          onRegisterClick={goToRegister}
          messageText={errorMessage}
        />
      )}
    </Formik>
  )
};

LoginForm.propTypes = {
  setUser: PropTypes.func,
  login: PropTypes.func
};

export default LoginForm;
